import http from '../utils/fetch';
export default {
    flAgainSure (sessionId,flag) {
        return http({
            url: '/api/swyl/v1/demo/flNewTarget/handelTargetFromTemp',
            method: 'post',
            params: {sessionId,flag}
        });
    }
}